import { Input } from "antd";
import type { ChangeEvent } from "react";

interface PhoneInputProps {
	value?: string;
	onChange?: (value: string) => void;
	id?: string;
	placeholder?: string;
	size?: "small" | "middle" | "large";
}

/**
 * O'zbekiston telefon raqami uchun input
 * - +998 prefix doimo ko'rinadi va o'chirib bo'lmaydi
 * - Faqat raqamlar qabul qilinadi
 * - Maksimum 9 ta raqam (+998 dan keyin)
 * - Format: XX XXX XX XX (vizual)
 * - Qiymat: +998XXXXXXXXX (form uchun)
 */
export function PhoneInput({
	value,
	onChange,
	id,
	placeholder = "90 123 45 67",
	size,
}: PhoneInputProps) {
	// +998XXXXXXXXX → XX XXX XX XX
	const formatDisplay = (raw: string): string => {
		// +998 ni olib tashlaymiz
		const digits = raw
			.replace(/^\+998/, "")
			.replace(/\D/g, "")
			.slice(0, 9);

		const parts: string[] = [];
		if (digits.length > 0) {
			parts.push(digits.slice(0, 2));
		}
		if (digits.length > 2) {
			parts.push(digits.slice(2, 5));
		}
		if (digits.length > 5) {
			parts.push(digits.slice(5, 7));
		}
		if (digits.length > 7) {
			parts.push(digits.slice(7, 9));
		}

		return parts.join(" ");
	};

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		const inputValue = e.target.value;
		// Faqat raqamlar
		const digits = inputValue.replace(/\D/g, "").slice(0, 9);
		// Form'ga +998XXXXXXXXX formatda beramiz
		onChange?.(`+998${digits}`);
	};

	const displayValue = value ? formatDisplay(value) : "";

	return (
		<Input
			addonBefore="+998"
			value={displayValue}
			onChange={handleChange}
			maxLength={12} // "XX XXX XX XX" = 12 belgi (bo'sh joylar bilan)
			placeholder={placeholder}
			id={id}
			size={size}
			inputMode="numeric"
		/>
	);
}
